import React, { Fragment, useRef } from "react";
import "./AboutMe.css";
import aboutMeImage from "../images/about.png";
import aboutMeImageOne from "../images/cv.jpg";
import aboutMeImageTwo from "../images/diploma.jpg";
import aboutMeImageThree from "../images/uniimage.png";
import aboutMeImageFour from "../images/certificate.jpg";
import aboutMeImageFive from "../images/img.jpg";

const AboutMe = ({ language }) => {
  const imageRef = useRef(null);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = aboutMeImageOne;
    link.download = "image.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const redirectImage = () => {
    window.open(
      "https://exclusivetv.ge/news/emigracia/qartveli-emigranti-evroparlamentshi-espanets-tsaradgens",
      "_blank"
    );
  };

  return (
    <Fragment>
      <h1 id="aboutme" className="aboutme-title">
        {language.aboutMe}
      </h1>
      <div className="aboutme-page">
        <div
          className="aboutme-text"
          style={{ marginTop: "20px", marginBottom: "30px" }}
        >
          <h1>{language.aboutMeText}</h1>
        </div>
        <div className="aboutme-image">
          <img src={aboutMeImage} alt="aboutImage" />
        </div>
        <h1 style={{ width: "100%" }} className="aboutme-title">
          {language.education}
        </h1>
        <div className="aboutme-text">
          <h1>{language.educationText}</h1>
        </div>
        <div className="aboutme-image">
          <img
            style={{
              cursor: "pointer",
            }}
            ref={imageRef}
            onClick={handleDownload}
            height="500px"
            src={aboutMeImageOne}
            alt="aboutImage"
          />
        </div>
        <div className="aboutme-image">
          <img height="500px" src={aboutMeImageTwo} alt="aboutImage" />
        </div>
        <div className="aboutme-image">
          <img height="500px" src={aboutMeImageThree} alt="aboutImage" />
        </div>
        <h1 style={{ width: "100%" }} className="aboutme-title">
          {language.achievement}
        </h1>
        <div className="aboutme-image">
          <img height="500px" src={aboutMeImageFour} alt="aboutImage" />
        </div>
        <div
          style={{
            cursor: "pointer",
          }}
          className="aboutme-image"
          onClick={redirectImage}
        >
          <img height="500px" src={aboutMeImageFive} alt="aboutImage" />
        </div>
      </div>
    </Fragment>
  );
};

export default AboutMe;
